// source: inv_common_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.Page', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.Common.v1.Version', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.Version, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.Version';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.Page, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.Page';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.displayName = 'proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.HealthzResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.repeatedFields_ = [13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.toObject = function(includeInstance, msg) {
  var f, obj = {
contractName: jspb.Message.getFieldWithDefault(msg, 1, ""),
contractTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
inventoryName: jspb.Message.getFieldWithDefault(msg, 3, ""),
position: msg.getPosition_asB64(),
jsonData: jspb.Message.getFieldWithDefault(msg, 5, ""),
fsrName: jspb.Message.getFieldWithDefault(msg, 6, ""),
assignedTo: jspb.Message.getFieldWithDefault(msg, 7, ""),
statusWeb: jspb.Message.getFieldWithDefault(msg, 8, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
auditMode: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
audited: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
auditorName: jspb.Message.getFieldWithDefault(msg, 12, ""),
versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.toObject, includeInstance),
tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.toObject, includeInstance),
serviceType: jspb.Message.getFieldWithDefault(msg, 15, ""),
geofence: msg.getGeofence_asB64(),
createdOn: (f = msg.getCreatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
eventDate: (f = msg.getEventDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
contractTimeZone: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryName(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPosition(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonData(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFsrName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignedTo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusWeb(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAuditMode(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAudited(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditorName(value);
      break;
    case 13:
      var value = new proto.Olameter.WFMS.InventoryManagement.Common.v1.Version;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    case 14:
      var value = new proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceType(value);
      break;
    case 16:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setGeofence(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedOn(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventDate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractTimeZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInventoryName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPosition_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getJsonData();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFsrName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAssignedTo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatusWeb();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getAuditMode();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getAudited();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getAuditorName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.serializeBinaryToWriter
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.serializeBinaryToWriter
    );
  }
  f = message.getServiceType();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getGeofence_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      16,
      f
    );
  }
  f = message.getCreatedOn();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEventDate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContractTimeZone();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string contract_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contract_title = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getContractTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setContractTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string inventory_name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes position = 4;
 * @return {!(string|Uint8Array)}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getPosition = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes position = 4;
 * This is a type-conversion wrapper around `getPosition()`
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getPosition_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPosition()));
};


/**
 * optional bytes position = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPosition()`
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getPosition_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPosition()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setPosition = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional string json_data = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getJsonData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setJsonData = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string fsr_name = 6;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getFsrName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setFsrName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string assigned_to = 7;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getAssignedTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setAssignedTo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string status_web = 8;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getStatusWeb = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setStatusWeb = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool active = 9;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool audit_mode = 10;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getAuditMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setAuditMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool audited = 11;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getAudited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setAudited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string auditor_name = 12;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getAuditorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setAuditorName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated Version versions = 13;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version>}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.Common.v1.Version, 13));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setVersionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.Olameter.WFMS.InventoryManagement.Common.v1.Version, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.clearVersionsList = function() {
  return this.setVersionsList([]);
};


/**
 * repeated InventoryTask tasks = 14;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask>}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask, 14));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};


/**
 * optional string service_type = 15;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getServiceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setServiceType = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bytes geofence = 16;
 * @return {!(string|Uint8Array)}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getGeofence = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * optional bytes geofence = 16;
 * This is a type-conversion wrapper around `getGeofence()`
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getGeofence_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getGeofence()));
};


/**
 * optional bytes geofence = 16;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getGeofence()`
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getGeofence_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getGeofence()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setGeofence = function(value) {
  return jspb.Message.setProto3BytesField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp created_on = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getCreatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setCreatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.clearCreatedOn = function() {
  return this.setCreatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.hasCreatedOn = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp event_date = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getEventDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setEventDate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.clearEventDate = function() {
  return this.setEventDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.hasEventDate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string contract_time_zone = 19;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.getContractTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.prototype.setContractTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.toObject = function(includeInstance, msg) {
  var f, obj = {
inventoryName: jspb.Message.getFieldWithDefault(msg, 1, ""),
jsonData: jspb.Message.getFieldWithDefault(msg, 2, ""),
fsrName: jspb.Message.getFieldWithDefault(msg, 3, ""),
assignedTo: jspb.Message.getFieldWithDefault(msg, 4, ""),
version: jspb.Message.getFieldWithDefault(msg, 5, 0),
audited: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
auditorName: jspb.Message.getFieldWithDefault(msg, 7, ""),
isSelected: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
createdOn: (f = msg.getCreatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
name: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.Version;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFsrName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignedTo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAudited(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditorName(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSelected(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedOn(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJsonData();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFsrName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssignedTo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAudited();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAuditorName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsSelected();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCreatedOn();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string inventory_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string json_data = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getJsonData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setJsonData = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string fsr_name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getFsrName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setFsrName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string assigned_to = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getAssignedTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setAssignedTo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 version = 5;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool audited = 6;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getAudited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setAudited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string auditor_name = 7;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getAuditorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setAuditorName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_selected = 8;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getIsSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setIsSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp created_on = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getCreatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setCreatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.clearCreatedOn = function() {
  return this.setCreatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.hasCreatedOn = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string name = 10;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Version} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Version.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.toObject = function(includeInstance, msg) {
  var f, obj = {
inventoryWorkFlowName: jspb.Message.getFieldWithDefault(msg, 1, ""),
inventoryName: jspb.Message.getFieldWithDefault(msg, 2, ""),
inventoryTaskName: jspb.Message.getFieldWithDefault(msg, 3, ""),
inventoryWorkFlowTaskName: jspb.Message.getFieldWithDefault(msg, 4, ""),
taskStatus: jspb.Message.getFieldWithDefault(msg, 5, ""),
comment: jspb.Message.getFieldWithDefault(msg, 6, ""),
completedBy: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryWorkFlowName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryTaskName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryWorkFlowTaskName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletedBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryWorkFlowName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInventoryName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInventoryTaskName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInventoryWorkFlowTaskName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTaskStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCompletedBy();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string inventory_work_flow_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.getInventoryWorkFlowName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.setInventoryWorkFlowName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string inventory_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.getInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.setInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string inventory_task_name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.getInventoryTaskName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.setInventoryTaskName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string inventory_work_flow_task_name = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.getInventoryWorkFlowTaskName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.setInventoryWorkFlowTaskName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string task_status = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.getTaskStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.setTaskStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string comment = 6;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string completed_by = 7;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.getCompletedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryTask.prototype.setCompletedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.toObject = function(includeInstance, msg) {
  var f, obj = {
taskName: jspb.Message.getFieldWithDefault(msg, 1, ""),
contractName: jspb.Message.getFieldWithDefault(msg, 2, ""),
inventoryName: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileExtension: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileType: jspb.Message.getFieldWithDefault(msg, 5, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 6, ""),
fileByte: msg.getFileByte_asB64(),
createdOn: (f = msg.getCreatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileExtension(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileByte(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInventoryName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileExtension();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFileByte_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
  f = message.getCreatedOn();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string task_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getTaskName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setTaskName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contract_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string inventory_name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_extension = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getFileExtension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setFileExtension = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string file_type = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getFileType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setFileType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string file_name = 6;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bytes file_byte = 7;
 * @return {!(string|Uint8Array)}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getFileByte = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes file_byte = 7;
 * This is a type-conversion wrapper around `getFileByte()`
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getFileByte_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileByte()));
};


/**
 * optional bytes file_byte = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileByte()`
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getFileByte_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileByte()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setFileByte = function(value) {
  return jspb.Message.setProto3BytesField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_on = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.getCreatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.setCreatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.clearCreatedOn = function() {
  return this.setCreatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileManagement.prototype.hasCreatedOn = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.toObject = function(includeInstance, msg) {
  var f, obj = {
taskName: jspb.Message.getFieldWithDefault(msg, 1, ""),
contractName: jspb.Message.getFieldWithDefault(msg, 2, ""),
inventoryName: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInventoryName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string task_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.getTaskName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.setTaskName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contract_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string inventory_name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.getInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.setInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_name = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.FileUploadError.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.toObject = function(includeInstance, msg) {
  var f, obj = {
fsrName: jspb.Message.getFieldWithDefault(msg, 1, ""),
inventoriesList: jspb.Message.toObjectList(msg.getInventoriesList(),
    proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFsrName(value);
      break;
    case 2:
      var value = new proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.deserializeBinaryFromReader);
      msg.addInventories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFsrName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInventoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory.serializeBinaryToWriter
    );
  }
};


/**
 * optional string fsr_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.getFsrName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.setFsrName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Inventory inventories = 2;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory>}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.getInventoriesList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory, 2));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.setInventoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.addInventories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Olameter.WFMS.InventoryManagement.Common.v1.Inventory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.InventoryAggregate.prototype.clearInventoriesList = function() {
  return this.setInventoriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.toObject = function(includeInstance, msg) {
  var f, obj = {
contractId: jspb.Message.getFieldWithDefault(msg, 1, ""),
serviceType: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServiceType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string contract_id = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.prototype.getContractId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.prototype.setContractId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string service_type = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.prototype.getServiceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.ContractServiceType.prototype.setServiceType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.toObject(includeInstance, f),
filters: (f = msg.getFilters()) && proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Olameter.WFMS.InventoryManagement.Common.v1.Page;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 2:
      var value = new proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.serializeBinaryToWriter
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.serializeBinaryToWriter
    );
  }
};


/**
 * optional Page page = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.Common.v1.Page}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.getPage = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.Common.v1.Page} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.WFMS.InventoryManagement.Common.v1.Page, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.Common.v1.Page|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CompositeFilterDescriptor filters = 2;
 * @return {?proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.getFilters = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor, 2));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Page} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.toObject = function(includeInstance, msg) {
  var f, obj = {
skip: jspb.Message.getFieldWithDefault(msg, 1, 0),
take: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Page}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.Page;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Page} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Page}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSkip(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTake(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Page} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkip();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTake();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 skip = 1;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.prototype.getSkip = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Page} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.prototype.setSkip = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 take = 2;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.prototype.getTake = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.Page} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.Page.prototype.setTake = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
logic: jspb.Message.getFieldWithDefault(msg, 1, ""),
field: jspb.Message.getFieldWithDefault(msg, 2, ""),
operator: jspb.Message.getFieldWithDefault(msg, 3, ""),
value: jspb.Message.getFieldWithDefault(msg, 4, ""),
ignoreCase: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor;
  return proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogic(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoreCase(value);
      break;
    case 6:
      var value = new proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLogic();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIgnoreCase();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.serializeBinaryToWriter
    );
  }
};


/**
 * optional string logic = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.getLogic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.setLogic = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string field = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.setField = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string operator = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string value = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool Ignore_case = 5;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.getIgnoreCase = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.setIgnoreCase = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated CompositeFilterDescriptor filters = 6;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor>}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor, 6));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} returns this
*/
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor}
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor} returns this
 */
proto.Olameter.WFMS.InventoryManagement.Common.v1.CompositeFilterDescriptor.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};


goog.object.extend(exports, proto.Olameter.WFMS.InventoryManagement.Common.v1);
